<template>
  <v-form v-model="valid">
    <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        :retain-focus="false"
        transition="dialog-bottom-transition"
    >
      <v-overlay absolute :value="isLoading">
        <v-progress-circular indeterminate size="32" />
      </v-overlay>
      <v-layout fill-height column class="form-item white"
                style="padding-top: var(--system-bar-height) !important;">
        <v-toolbar
            color="white"
            elevation="0"
            class="flex-grow-0"
        >
          <v-toolbar-title>
            광장에 남기기
          </v-toolbar-title>
          <v-spacer />
          <v-btn icon plain :ripple="false" @click="close">
            <Close/>
          </v-btn>
        </v-toolbar>
        <template v-if="content">
          <v-container flex-fill fluid class="py-0">
            <v-textarea
                v-model.lazy="inputVal"
                filled
                solo
                flat
                no-resize
                background-color="#fff"
                placeholder="수정할 내용을 적어주세요."
                counter="500"
                :rules="[rules.required, rules.trim, rules.length(500)]"
            />
          </v-container>
          <v-container class="py-0">
            <div class="square-unit-info remove-router">
              <div class="tit">{{ payload.item.unitTitle }}</div>
              <div class="txt">
                {{ payload.item.duraTime | duraTimeSec }} | {{ payload.item.helpfulCdNm }}
              </div>
            </div>
          </v-container>
        </template>
        <div class="footer-btns vertical">
          <p class="fs-13">
            ※ 욕설 혹은 비방글을 남기면 운영 정책에 의해 서비스 이용이 제한될 수 있습니다.
          </p>
          <v-btn color="primary" class="btn-submit"
                 x-large depressed
                 :loading="isLoading"
                 :disabled="isLoading || !valid"
                 @click="save()">게시하기</v-btn>
        </div>
      </v-layout>
    </v-dialog>
  </v-form>
</template>
<script>
import store from '@/store'
import Close from '@/components/icons/Close'

export default {
  components: {
    Close,
  },
  data: () => ({
    isLoading: false,
    dialog: false,
    payload: null,
    content: null,
    valid: false,
    inputVal: null,
    rules: {
      required: v => !!v || '필수 값입니다.',
      trim: v => (!!v && v.trim() !== '') || '공백만 작성 할 수 없습니다.',
      length: len => v => (v || '').length <= len || `${len}자 미만으로 작성 할 수 있습니다.`,
    }
  }),

  filters: {
    duraTimeSec: function (value) {
      if (value == '') return '';
      return value + ':00';
    }
  },
  methods: {
    reset () {
      this.isLoading = false
      this.payload = null
      this.content = null
      this.valid = false
      this.inputVal = null
    },
    open (value) {
      this.payload = value
      this.readOne()
    },
    close () {
      this.reset()
      this.dialog = false
    },
    save () {
      this.$emit('onEvent', {fn: 'editUnit', item: this.payload.item, index: this.payload.index, inputVal: this.inputVal.trim()});
      this.close()
    },
    async readOne () {
      this.isLoading = true
      // this.seleteItem = item;
      await store.dispatch('getSquareOne', this.$_payload({'squareNo': this.payload.item.squareNo}))
          .then(res => {
            if (res.success) {
              this.content = res.data
              this.inputVal = res.data.content
              this.dialog = true
            } else {
              this.close()
            }
          })
          .catch(error => {
            console.error(error)
            this.close()
          })
          .finally(() => {
            this.isLoading = false
          })
    },
  }
}
</script>
